import type { PropsWithChildren } from "react";

import { StyledFooter } from "./styles";

const PanelFooter = ({ children }: PropsWithChildren) => {
    return <StyledFooter data-automation="filter-panel-categories.footer-wrapper">{children}</StyledFooter>;
};

export default PanelFooter;
